/* vf-events.js (spec §8, T013) — window.vfTrack(name, payload) → Shopify.analytics.publish('vitrine:' + name, payload).
   Add ?vf_debug=1 to any URL to log events in the console. Never send personal data in payloads. */
(function () {
  var debug = /[?&]vf_debug=1\b/.test(location.search);
  function publish(name, payload) {
    var data = payload && typeof payload === 'object' ? payload : {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('vitrine:' + name, data);
      }
    } catch (e) { /* analytics must never break the page */ }
    if (debug && window.console) console.debug('[vfTrack]', name, data);
  }
  var queued = window.vfTrackQueue || [];
  window.vfTrack = publish;
  window.vfTrackQueue = { push: function (item) { publish(item[0], item[1]); } };
  for (var i = 0; i < queued.length; i++) publish(queued[i][0], queued[i][1]);
})();
